import { red300 } from 'ext-ui/style/colors'
import { css } from 'styled-components'

export default css`
  &.DisconnectPhysicalCardModal .BaseModal-Body {
    position: relative;

    .corner-img {
      position: absolute;
      top: 0;
      right: 0;
      border-top-right-radius: 10px;
    }
  }

  .has-disconnect strong {
    color: ${red300};
  }
`
